import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { apartmentSVG, houseSVG, mediumApartmentSVG, mediumHouseSVG } from '../../../../../assets/svgIcons';

import { updateFilters } from '../../../../reducers/filtersSlice';

const TypeCheckbox = () => {
  const { collection: filtersCollection } = useSelector((state) => state.filters);
  const { desktopDevice } = useSelector((state) => state.viewportSlice);
  const { type } = filtersCollection
  const dispatch = useDispatch();

  const checkboxes = [{inputName: 'apartment', displayName: 'Appartement'}, {inputName: 'house', displayName: 'Maison'}]

  const handleIcons = (inputName) => {
    if (desktopDevice) return inputName === 'apartment' ? apartmentSVG() : houseSVG();

    return inputName === 'apartment' ? mediumApartmentSVG() : mediumHouseSVG();
  }

  return(
    <div className='vesta-flex-row-start'>
      {checkboxes.map(({ inputName, displayName }, index) => (
        <div key={index} className={`vesta-${desktopDevice ? 'small' : 'medium'}-checkbox-card-container vesta-margin-r-15`}>
          <input
            id={`${inputName}`}
            type='checkbox'
            name={`${inputName}`}
            checked={type[inputName]}
            readOnly
            onClick={() => dispatch(updateFilters(
              {...filtersCollection,
                type: {...type, [inputName]: !type[inputName]}
              }
            ))}
          />

          <label htmlFor={`${inputName}`} className={`vesta-${desktopDevice ? 'small' : 'medium'}-checkbox-card vesta-gap-10`} >
            <div className='vesta-checkbox-custom'>
              <i className='fa-solid fa-check vesta-no-margin-important'></i>
            </div>

            {handleIcons(inputName)}

            {displayName}
          </label>
        </div>
      ))}
    </div>
  )
};

export default TypeCheckbox;
